import React, {useState} from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../../components/Footer';
import FormInput from '../../../components/FormInput';

// verificar colocar for=ID nos label
import { Error } from '../../../components/Erro'
import useForm from '../../../hooks/useForm';
import useAuth from '../../../hooks/useAuth';
import Loading from '../../../components/Loading';
import {ConfirmPasswordInput} from '../../../components/auth';
import {ErroAviso} from  '../../../components/Erro'

import "./resetar.css";

function MudarSenha() {
    const [home,setHome] = useState(true)
    const [sucess,setSucess] = useState(false)
    return (
    <>

        {!!home && <PageHome setHome={setHome} setSucess={setSucess}/>}
        {!home && !!sucess && <PageSucess/>}
        {!home && !sucess &&
        <div>
            {/* <HelpPage/> */}
            <Page setSucess={setSucess}/>
            <Footer />
        </div>}
    </>
    );
}

export default MudarSenha;

function Page({setSucess}) {

    const { values, handleChange: _handleChange } = useForm({
        initialValues: {
            email: "",
            username: "",
            cpf: "",
            nascimento: "",
            password:"",
            passwordConfirm:""

        }
    })

    const handleChange = (event) => {
        if (event.target.name === 'cpf') {
            const value = event.target.value.replace(/\D/g, '')
            if (value.length > 10) {
                event.target.value = value.slice(0, 3) + "." +
                    value.slice(3, 6) + "." +
                    value.slice(6, 9) + "-" +
                    value.slice(9, 11)
            }
        }
        if (event.target.name === 'cep') {
            const value = event.target.value.replace(/\D/g, '')
            if (value.length > 5) {
                event.target.value = value.slice(0, 5) +
                    "-" +
                    value.slice(5, 8)
            }
        }
        _handleChange(event)
    }
    //const [ok, setOk] = useState(false);
    const { chargerPassword, error, loading} = useAuth();

    const handleChangePass = async (e) => {
        e.preventDefault();
        const sucess = await chargerPassword(values);
        setSucess(sucess ==='sucess')
    };
    return (
    <form onSubmit={handleChangePass}>
        <section className="section-block">
            <div className="wrapper">
                {/* <h2  className="title">Trocar Senha</h2> */}
                <i className=''/>
                <div className="Form__notif">
                    {!!error && <Error error={error.messages}/>}
                </div>
            </div>
        </section>
        <section className="wrapper">
            <div className="">
            <h2 className="title">Esqueceu a senha?</h2>
            <div className="form-group form-icon">
                <p className='djbox-texto'>Sem problemas, </p>
                <p className='djbox-texto'>Preencha as informações abaixo que vamos te ajudar</p>
            </div>
            <div className="form-group form-icon">
                <label htmlFor="email" className="form-label">E-mail</label>
                <FormInput type={"email"}
                    placeholder={"Coloque aqui o seu email"}
                    name={"email"}
                    value={values.email.toLowerCase()}
                    handleChange={handleChange}
                    autoComplete={"email"}
                    className={"form-input"}
                    required={true}
                />
            </div>
            {/* <div>
                <BtnsHorizontal/>
            </div> */}
            <div className="form-group form-icon">
                <label htmlFor="nascimento" className="form-label">Nascimento:</label>
                <FormInput type={"date"}
                    placeholder={"dia/mes/ano"}
                    name={"nascimento"}
                    value={values.nascimento}
                    handleChange={handleChange}
                    className={"form-input"}
                    required={true}
                    max={'2020/10/28'}
                    min={'1900/10/28'}
                />
            </div>

            <ConfirmPasswordInput
                name={"password"}
                value={values.password}
                nameConfirm={"passwordConfirm"}
                valueConfirm={values.passwordConfirm}
                handleChange={handleChange}
            />
        </div>
        </section>
        <section className="section-block">
            <div className='wrapper djVerticalCenter'>
                <div className="Form__notif">
                    {!!error && <Error error={error.messages}/>}
                </div>
            <button
                className="djbtn-default djbtn-verde djbtn"
                type={true ? "submit" : "none"}
            > Enviar!</button>

            <Link className='djbtn-a' to='/Login'>
            <button type="button" className=" djbtn-default djbtn-branco djbtn">
                Voltar
            </button>
            </Link>
            </div>
        </section>
        {loading==='Loading' && <div className='pop-up-load'>
            <Loading texto='conectando ao servidor' loading={loading}/>
        </div>}
    </form>)
};


function PageSucess () {

    const textosProps = {
        titulo:   "Ebaa",
        aviso:'Senha Atualizada, com Sucesso!',
        legenda:  "Boa, agora é fazer o login e aproveitar os estudos.",
        btn_texto:"Clique aqui para fazer o Login",
        btn_to:   "/login"
    };

    return ( <ErroAviso
            titulo  = {textosProps.titulo}
            aviso  = {textosProps.aviso}
            description  = {textosProps.legenda}
            btn_text  = {textosProps.btn_texto}
            btn_to  = {textosProps.btn_to}
        /> )
}
function PageHome ({setHome, setSucess}) {
    const textosProps = {
        titulo: "Eita!",
        aviso:  'esqueceu sua senha?',
        legenda: "Não esquenta, vamos dar um jeito nisso.",
        btn_texto:"Clique aqui para trocar a senha",
        btn_to:   "#trocarSenha",
        // btn_to:   ()=>{setHome(false);setSucess(true);return '/trocarSenha'},
        btn_OnClick:()=>{setHome(false)}
    };

    return ( <ErroAviso
            titulo  = {textosProps.titulo}
            aviso  = {textosProps.aviso}
            description  = {textosProps.legenda}
            btn_text  = {textosProps.btn_texto}
            btn_to  = {textosProps.btn_to}
            btn_OnClick  = {textosProps.btn_OnClick}
        /> )
}

// console.log(typeof(BtnsHorizontal))
// function BtnsHorizontal(props){
//
//     const btns = [
//         {name:'CPF',value:'checked'},
//         {name:'Nascimento',value:'checked'}
//     ]
//     // const botoes = btns.map((name, value, handleChange)=>{
//     //     return (<label htmlFor={name}>
//     //         {name}
//     //         <input type="radio"
//     //             key={name}
//     //             name={name}
//     //             value={value}
//     //             onChange={handleChange}
//     //             style={{display:'none'}}
//     //         />
//     //     </label>)
//     // })
//
//     // return ({botoes})
//
//     const a = btns[0]
//     const btn = <label htmlFor={a.name}
//             className={'ranking-header-btn djbtn-selectt-label'}
//             >
//          {a.name}
//          <input type="radio"
//              key={a.name}
//              name={a.name}
//              value={a.value}
//              onChange={a.handleChange}
//              style={{display:'none'}}
//          />
//      </label>
//     return (<div className='djbtn-selectt'> {btn}{btn}</div>)
// }
